import { Event, sample } from 'effector';
import { translated } from '../effector-i18next';
import { notifications, ShowNotificationPayload } from './notifications';

export type NotifyParams = Partial<ShowNotificationPayload>;

export const notify = <TPayload>(clock: Event<TPayload>, key: string, params?: NotifyParams) => {
	sample({
		clock,
		source: translated(key),
		fn: (message) => ({ message, ...params }),
		target: notifications.showSuccess,
	});
};
